import { render, staticRenderFns } from "./ExpenseCaptureForm.vue?vue&type=template&id=ccf72f40"
import script from "./ExpenseCaptureForm.vue?vue&type=script&lang=js"
export * from "./ExpenseCaptureForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports